import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { I18nProvider } from '../i18n';
import { PrefsProvider } from './prefs';
import { LinkInterceptor } from './LinkInterceptor';
import { MenuDismiss } from './MenuDismiss';
import { AppRoutes } from './router';
import { QueryProvider } from '../api/query';

export function App() {
  return (
    <QueryProvider>
      <PrefsProvider>
        <I18nProvider>
          <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
            <LinkInterceptor />
            <MenuDismiss />
            <AppRoutes />
          </BrowserRouter>
        </I18nProvider>
      </PrefsProvider>
    </QueryProvider>
  );
}
